import {useState} from "react";
import {Formik} from "formik";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import Swal from "sweetalert2";

import infoIcon from "../../../../images/icons/infoIcon.png";
import {createTemplate} from "../../../../slices/KPSlice";
import FunctionButton from "../../../../utilities/Buttons/FunctionButton";
import ImageButton from "../../../../utilities/Buttons/ImageBtn";
import {TextAreaInput} from "../../../Inputs";

const TemplateCreateFromKpModal = ({currentCOf, setModalActive}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [modalKey, setModalKey] = useState(0);

  const onCreateTemplateClick = (templateNote, resetForm) => {
    if (!currentCOf?.cofId) return;

    dispatch(createTemplate({cofId: currentCOf.cofId, note: templateNote}))
      .unwrap()
      .then(() => {
        Swal.fire({
          title: "",
          text: t("Template created"),
          icon: "info",
          confirmButtonText: t("Ok"),
          showCancelButton: false,
        });
        setModalActive(false);
        resetForm();
        setModalKey(prev => prev + 1);
      })
      .catch(err => {
        console.error(err);
      });
  };

  return (
    <Formik key={modalKey} initialValues={{modalTCOnote: ""}} onSubmit={() => {}}>
      {({values, resetForm}) => (
        <div style={{padding: "2em 3em"}} className="fdc">
          <div className="fdr aic mb3x mt gap2x" style={{fontSize: "20px", minWidth: "40em"}}>
            <ImageButton src={infoIcon} alt="info" width={3} height={3} />
            <div className="fcCols gap aic jcc w100">
              <div>{t("New temp create text")}</div>
              <div>
                {t("from CO(f) №")} {currentCOf?.cofNumber}
              </div>
            </div>
          </div>

          <div className="fdr aic w100 mb2x">
            <div style={{width: "12em", marginRight: "5em"}}>{t("Notes on tCO")}</div>
            <TextAreaInput name="modalTCOnote" label="" width="100%" />
          </div>

          <div className="fdr jcse  aic mt">
            <FunctionButton
              name={t("Template")}
              onClick={() => onCreateTemplateClick(values?.modalTCOnote, resetForm)}
              autoWidth
            />

            <FunctionButton
              name={t("Cancel")}
              onClick={() => {
                resetForm();
                setModalKey(prev => prev + 1);
                setModalActive(false);
              }}
              autoWidth
            />
          </div>
        </div>
      )}
    </Formik>
  );
};

export default TemplateCreateFromKpModal;
